var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{class:_vm.logoClasses,attrs:{"id":"logo","to":"/"}},[_c('img',{staticClass:"image",class:_vm.imgClasses,attrs:{"alt":"Card Trip","src":require("@/assets/img/logo/logo_rgb.png")},on:{"click":_vm.scrollToTop}})])}
var staticRenderFns = []

export { render, staticRenderFns }